
import React from 'react'
import '../styles/services.css';  





export default function Services() {
  
  return (
    <div className='formation'>
        <div >      
              <h2 id='form'> Nos objectifs spécifiques : </h2>
        </div>
        <div className='dispo'>
            <div >Promouvoir la micro-finance et la création des
            micro-projets</div>
            <div >Renforcer les capacités techniques et organisationnelles des
            populations rurales</div>
            <div >Promouvoir l’investissement privé et la création de l’emploi</div>
            <div >Appuyer à la création des associations et des structures
            professionnelles agricoles</div>
            <div>Contribuer à la planification, mise en œuvre et suivi des
            projets de développement</div>
        </div>
        
        
        
        </div>
  )
}
